// extracted by mini-css-extract-plugin
module.exports = {"button":"app-button_button___6n8k","googleplay-on-ios":"app-button_googleplay-on-ios__NJp6b","appstore-on-android":"app-button_appstore-on-android__IdHam"};